module.exports = __webpack_public_path__ + "static/media/intro-background-2.03a2be03.png";